export {default} from './PendingTip';
